import React from 'react';
import { useNavigate } from 'react-router-dom';
import CustomIcon from '../../components/CustomIcon.tsx';
import { useJournalContext } from '../../contexts/journal.tsx';
import { useUsersContext } from '../../contexts/users.tsx';
import FormatDate from '../../models/helpers/formatDate.ts';
import { JournalName } from '../../models/JournalName.ts';
import { JournalDays } from './components/journalDays.tsx';
import { JournalGroup } from './components/journalGroup.tsx';
import JournalDayProgress from './components/journalDayProgress.tsx';

const JournalBody = () => {
    const {
        groupedJournals,
        searchParam
    } = useJournalContext();
    const {
        measurementUnits,
        journalNames
    } = useUsersContext()
    const navigate = useNavigate();

    groupedJournals.forEach(group => {
        if (!journalNames.find(jn => jn.name == group[0].name))
            journalNames.push({ name: group[0].name } as JournalName);
    });

    return (
        <>
            <JournalDays />

            <div className="mt-3 mb-4">

                <JournalDayProgress selectedDate={searchParam.dateTime} />

                {
                    journalNames.map((jn) => groupedJournals.filter(jg => jg[0].name == jn.name)?.map(group => (
                        <JournalGroup
                            journalGroup={group ?? []}
                            handleInputChange={() => { }}
                            displayName
                        />
                    )))
                }
            </div>
            <div className='fixed-bottom d-flex flex-row justify-content-end p-3 maxw-1920'
                onClick={() => navigate(`/journal/${FormatDate(searchParam.dateTime)}`)}
            >
                <CustomIcon name='addJournal' />
            </div>
        </>
    );
};

export default JournalBody;